import useApiRecord from "hooks/use_api_record"

const useAppEvent = (id, data = {}) => {
  const app = "check-ins"
  const path = `/app_events`
  const defaultData = {
    fields: {
      AppEvent: "source_id, app_event_sessions, app_event_labels",
      AppEventLabel: "conditional_types, label",
      AppEventSession: "shows_at, hides_at",
      Label: "name, prints_for"
    },
    include: ["app_event_labels", "app_event_labels.label", "app_event_sessions"]
  }

  const { loading, errors, record } = useApiRecord({
    id,
    app,
    path,
    data: { ...defaultData, ...data }
  })

  const appEventSessions = record?.appEventSessions?.sort((a, b) =>
    a.showsAt < b.showsAt ? -1 : a.showsAt > b.showsAt ? 1 : 0
  )

  return {
    loading,
    errors,
    appEvent: { ...record, appEventSessions },
  }
}

export default useAppEvent
